'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { createTranslator, DEFAULT_LOCALE } from '@xdocs/i18n';
/**
 * React binding for `@xdocs/i18n` (a locale-agnostic leaf package with no
 * ambient context of its own, per its own docs). `@xdocs/ui` is the natural
 * owner of this binding: it is the only Phase-0 package that both depends on
 * `@xdocs/i18n` AND renders React, and every component in this package needs
 * `t()` for its OWN copy (DataTable pagination/empty/error strings, Modal's
 * close label, ConfirmDialog's Cancel/Confirm, LanguageSwitcher labels).
 * `apps/web`/`apps/landing` mount `<LocaleProvider>` once at the shell root
 * and re-render it when `users.locale` changes.
 */
const LocaleContext = createContext(createTranslator(DEFAULT_LOCALE));
export function LocaleProvider({ locale, children }) {
    const translator = useMemo(() => createTranslator(locale), [locale]);
    return _jsx(LocaleContext.Provider, { value: translator, children: children });
}
/** `const { t, locale } = useI18n();` — the one hook every `@xdocs/ui`
 * component (and every consumer) uses to resolve catalog message ids. */
export function useI18n() {
    return useContext(LocaleContext);
}
